function ResponsiveTables() {
	document
		.querySelectorAll('.component-container table')
		.forEach(function (table) {
			// Avoid double-wrapping.
			if (table.closest('.table-responsive')) {
				return;
			}
			var wrapper = document.createElement('div');
			wrapper.className = 'table-responsive';
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		});
}

export default ResponsiveTables;